/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useNavigate } from "react-router-dom"
import { Button, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet';

const Profile = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth)
  const [currentUser, setCurrentUser] = useState({});
  useEffect(() => {
    if (!user) {
      return
    }
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    }
    axios
        .get('/api/users/me', config)
        .then(res => setCurrentUser(res.data))
        .catch(err => toast.error(err))
  },[]);

  return (
      <Container style={{ width: "600px" }}>
        <Helmet>
          <title>{user ? `${user.firstName}'s Profile - Pop Zombie` : "User Profile - Pop Zombie"}</title>
          <meta name="description" content={user ? `${user.firstName}'s profile information in the application.` : "User's profile information in the application."} />
        </Helmet>


        <div className="p-3 box" style={{backgroundColor: "#ffffff"}}>
          <h3 className="mb-3 text-center" style={{color: "#15a2fa"}}>My Profile</h3>
          <div className="pb-2" style={{color: "#050505"}}>
            Display name: {currentUser.firstName} {currentUser.lastName}
          </div>
          <div className="pb-3" style={{color: "#050505"}}>
            Email: {currentUser.email}
          </div>
          {currentUser.image ? (
              <div className="pb-3">
                <img src={currentUser.image} alt='' className='author-image' />
              </div>
          ) : null}
          <div className="d-grid gap-2">
            <Button
                variant="secondary"
                type="submit"
                style={{backgroundColor: "#ffffff", borderColor: '#ffffff', color: "#15a2fa"}}
                onClick={() => navigate('/userForm/')}
            >
              Edit My Profile
            </Button>
            <Button
                variant="secondary"
                type="submit"
                style={{backgroundColor: "#ffffff", borderColor: '#ffffff', color: "#15a2fa"}}
                onClick={() => navigate('/userHome')}
            >
              Back to My Posts
            </Button>
          </div>

        </div>
      </Container>
  )
}

export default Profile
